import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { PlusIcon, TrashIcon } from 'lucide-react';
const HealthcarePOA = () => {
  const {
    register
  } = useFormContext();
  const [primaryAttorneys, setPrimaryAttorneys] = useState([{
    id: 1
  }]);
  const [alternateAttorneys, setAlternateAttorneys] = useState([{
    id: 1
  }]);
  const addPrimaryAttorney = () => {
    const newId = primaryAttorneys.length > 0 ? Math.max(...primaryAttorneys.map(a => a.id)) + 1 : 1;
    setPrimaryAttorneys([...primaryAttorneys, {
      id: newId
    }]);
  };
  const removePrimaryAttorney = (id: number) => {
    setPrimaryAttorneys(primaryAttorneys.filter(a => a.id !== id));
  };
  const addAlternateAttorney = () => {
    const newId = alternateAttorneys.length > 0 ? Math.max(...alternateAttorneys.map(a => a.id)) + 1 : 1;
    setAlternateAttorneys([...alternateAttorneys, {
      id: newId
    }]);
  };
  const removeAlternateAttorney = (id: number) => {
    setAlternateAttorneys(alternateAttorneys.filter(a => a.id !== id));
  };
  return <div className="space-y-8" data-id="element-802">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-803">
        <p className="text-slate-700" data-id="element-804">
          A Power of Attorney for Personal Care gives someone else the legal
          authority to make decisions about your healthcare, housing, and other
          personal matters if you become unable to make these decisions
          yourself.
        </p>
      </div>

      {/* Primary Attorneys */}
      <div className="space-y-4" data-id="element-805">
        <div className="flex justify-between items-center" data-id="element-806">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-807">
            Primary Attorney(s) for Personal Care
          </h3>
          <button type="button" onClick={addPrimaryAttorney} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-808">
            <PlusIcon size={16} className="mr-1" data-id="element-809" />
            Add Attorney
          </button>
        </div>

        <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-810">
          <p className="text-sm text-blue-800" data-id="element-811">
            You may name one or more Primary Attorneys. If you name multiple
            attorneys, you will need to specify whether they should act jointly
            (together) or independently (separately).
          </p>
        </div>

        {primaryAttorneys.map((attorney, index) => <div key={attorney.id} className="p-4 bg-slate-50 rounded-md" data-id="element-812">
            <div className="flex justify-between items-center mb-3" data-id="element-813">
              <h4 className="font-medium" data-id="element-814">Primary Attorney {index + 1}</h4>
              {primaryAttorneys.length > 1 && <button type="button" onClick={() => removePrimaryAttorney(attorney.id)} className="text-red-500 hover:text-red-700" data-id="element-815">
                  <TrashIcon size={16} data-id="element-816" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-817">
              <div data-id="element-818">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-819">
                  Name
                  <span className="text-red-500 ml-1" data-id="element-820">*</span>
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter attorney's name" {...register(`healthcarePOA.primary.${index}.name`)} data-id="element-821" />
              </div>
              <div data-id="element-822">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-823">
                  Relationship
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Spouse, Child, Friend" {...register(`healthcarePOA.primary.${index}.relationship`)} data-id="element-824" />
              </div>
              <div data-id="element-825">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-826">
                  Phone Number
                </label>
                <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register(`healthcarePOA.primary.${index}.phone`)} data-id="element-827" />
              </div>
            </div>
            <div className="mt-4" data-id="element-828">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-829">
                Address
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter attorney's address" {...register(`healthcarePOA.primary.${index}.address`)} data-id="element-830" />
            </div>
          </div>)}

        {/* Joint or Independent - only show if multiple primary attorneys */}
        {primaryAttorneys.length > 1 && <div className="p-4 bg-amber-50 rounded-md border border-amber-200" data-id="element-831">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-832">
              Should your primary attorneys act jointly or independently?
            </label>
            <div className="space-y-2" data-id="element-833">
              <label className="flex items-start" data-id="element-834">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="jointly" {...register('healthcarePOA.primaryActing')} data-id="element-835" />
                <span className="ml-2 block" data-id="element-836">
                  <span className="font-medium" data-id="element-837">Jointly</span>
                  <span className="text-sm text-slate-600 block" data-id="element-838">
                    All attorneys must agree and act together on all decisions.
                  </span>
                </span>
              </label>
              <label className="flex items-start" data-id="element-839">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="independently" {...register('healthcarePOA.primaryActing')} data-id="element-840" />
                <span className="ml-2 block" data-id="element-841">
                  <span className="font-medium" data-id="element-842">
                    Independently (Jointly and Severally)
                  </span>
                  <span className="text-sm text-slate-600 block" data-id="element-843">
                    Any one attorney can act alone without the others.
                  </span>
                </span>
              </label>
            </div>
          </div>}
      </div>

      {/* Alternate Attorneys */}
      <div className="space-y-4" data-id="element-844">
        <div className="flex justify-between items-center" data-id="element-845">
          <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-846">
            Alternate Attorney(s) for Personal Care
          </h3>
          <button type="button" onClick={addAlternateAttorney} className="flex items-center text-sm text-navy-700 hover:text-navy-900" data-id="element-847">
            <PlusIcon size={16} className="mr-1" data-id="element-848" />
            Add Attorney
          </button>
        </div>

        <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-849">
          <p className="text-sm text-blue-800" data-id="element-850">
            Alternate attorneys will act if your primary attorney(s) are unable
            or unwilling to act. You may name one or more alternates.
          </p>
        </div>

        {alternateAttorneys.map((attorney, index) => <div key={attorney.id} className="p-4 bg-slate-50 rounded-md" data-id="element-851">
            <div className="flex justify-between items-center mb-3" data-id="element-852">
              <h4 className="font-medium" data-id="element-853">Alternate Attorney {index + 1}</h4>
              {alternateAttorneys.length > 1 && <button type="button" onClick={() => removeAlternateAttorney(attorney.id)} className="text-red-500 hover:text-red-700" data-id="element-854">
                  <TrashIcon size={16} data-id="element-855" />
                </button>}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-856">
              <div data-id="element-857">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-858">
                  Name
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter alternate attorney's name" {...register(`healthcarePOA.alternate.${index}.name`)} data-id="element-859" />
              </div>
              <div data-id="element-860">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-861">
                  Relationship
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Sibling, Friend" {...register(`healthcarePOA.alternate.${index}.relationship`)} data-id="element-862" />
              </div>
              <div data-id="element-863">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-864">
                  Phone Number
                </label>
                <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register(`healthcarePOA.alternate.${index}.phone`)} data-id="element-865" />
              </div>
            </div>
            <div className="mt-4" data-id="element-866">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-867">
                Address
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={2} placeholder="Enter alternate attorney's address" {...register(`healthcarePOA.alternate.${index}.address`)} data-id="element-868" />
            </div>
          </div>)}

        {/* Joint or Independent for alternates - only show if multiple alternate attorneys */}
        {alternateAttorneys.length > 1 && <div className="p-4 bg-amber-50 rounded-md border border-amber-200" data-id="element-869">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-870">
              Should your alternate attorneys act jointly or independently?
            </label>
            <div className="space-y-2" data-id="element-871">
              <label className="flex items-start" data-id="element-872">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="jointly" {...register('healthcarePOA.alternateActing')} data-id="element-873" />
                <span className="ml-2 block" data-id="element-874">
                  <span className="font-medium" data-id="element-875">Jointly</span>
                  <span className="text-sm text-slate-600 block" data-id="element-876">
                    All attorneys must agree and act together on all decisions.
                  </span>
                </span>
              </label>
              <label className="flex items-start" data-id="element-877">
                <input type="radio" className="form-radio h-5 w-5 text-navy-600 mt-0.5" value="independently" {...register('healthcarePOA.alternateActing')} data-id="element-878" />
                <span className="ml-2 block" data-id="element-879">
                  <span className="font-medium" data-id="element-880">
                    Independently (Jointly and Severally)
                  </span>
                  <span className="text-sm text-slate-600 block" data-id="element-881">
                    Any one attorney can act alone without the others.
                  </span>
                </span>
              </label>
            </div>
          </div>}
      </div>
    </div>;
};
export default HealthcarePOA;